const PATCH_NOTES = [
  {
    title: `Versión ${process.env.VUE_APP_VERSION}`,
    date: '27 de Octubre de 2026',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Visualización de usuarios conectados en el Dashboard y en el grid de usuarios, permitiendo conocer qué usuarios tienen sesión activa en la aplicación.',
          'Ampliada la configuración de envío de emails a usuarios en los grupos, ofreciendo un mayor control sobre los avisos que recibe cada usuario.',
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Corrección de errores menores y mejoras en rendimiento y seguridad relacionadas con los datos en reposo.',
        ]
      },
    ]
  },
  {
    title: 'Versión 2.32',
    date: '3 de Junio de 2026',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          `Nuevo módulo: Asistente IA para Notificaciones Electrónicas.
Permite conectar EdasNEO con una Inteligencia Artificial para automatizar aún más la gestión de tus notificaciones electrónicas:
Permite clasificar y asignar automáticamente o con revisión las notificaciones al grupo de trabajo correspondiente por el contenido de la misma.
Resume de forma precisa cada notificación para acceder a su información clave (objetos, impacto, fechas, asunto, etc.) sin esfuerzo. 
Establece automáticamente o con revisión la fecha de fin de trámite a partir del contenido de la notificación.
El módulo opera según los controles y seguridad que marca AEGIS y la información se procesa en Azure Foundry (región Western Europe), garantizando un entorno seguro y controlado.
También puedes integrar esta funcionalidad con tu propio modelo corporativo de IA. Contacta con nosotros para coordinar la configuración.`,
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Corrección de errores menores y mejoras en la estabilidad en la aplicación.',
        ]
      },
    ]
  },
  {
    title: 'Versión 2.31',
    date: '19 de Marzo de 2026',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Nuevo módulo: "Contestación de diligencias a la AEAT". Permite responder directamente a la AEAT desde el detalle de las notificaciones de tipo diligencia, agilizando la gestión y el seguimiento de los trámites requeridos.',
          'Nuevas acciones de exportación y eliminación masiva de la lista blanca de emails, facilitando su gestión y mantenimiento.',
          'Nueva acción de reenvío de correo disponible para las notificaciones que se encuentran en estado de error de envío, permitiendo reintentar el envío de forma sencilla.',
          'Incorporada la visualización de las URLs de las sedes electrónicas en las vistas de sedes, proporcionando acceso directo a la web de cada sede.',
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Corrección de errores menores y mejoras en la estabilidad en la aplicación.',
        ]
      },
    ]
  },
  {
    title: 'Versión 2.30',
    date: '11 de Junio de 2025',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Nuevo módulo: "Hot Folder de correos". Se incorpora la entrada automática de notificaciones electrónicas a través de buzones de correo con sus respectivos adjuntos.',
          // 'Chatbot IA. Nuevo asistente virtual con inteligencia artificial para resolver dudas y brindar ayuda sobre el uso de la aplicación.',
          // 'Aplicar reglas manualmente. Ahora es posible aplicar manualmente el flujo de reglas a una o varias notificaciones, permitiendo mayor control y flexibilidad en el procesamiento.',
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Corrección de errores menores y mejoras en la estabilidad en la aplicación.',
        ]
      },
    ]
  },
  {
    title: 'Versión 2.29',
    date: '28 de Abril de 2025',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Se han reforzado las medidas de seguridad en el acceso de usuarios, mejorando la protección de las credenciales y los procesos de autenticación.',
          'Nuevo módulo: "Peticiones a APIs". Ahora es posible enviar datos de notificaciones a APIs externas previamente configuradas.',
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Corrección de errores menores y mejoras en la estabilidad en la aplicación.',
        ]
      },
    ]
  },
  {
    title: 'Versión 2.28',
    date: '9 de Abril de 2025',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Se han implementado mejoras de seguridad y una ampliación en el control del historial de contraseñas al actualizar la contraseña de un usuario.',
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Optimización visual y mayor claridad en la presentación de información dentro de la sección de Informe de Costes.',
          'Actualización en la sección de datos del responsable para Gran Destinatario en Dehú, permitiendo ahora el uso de los datos de Zerocoma.',
          'Corrección de errores menores y mejoras en la estabilidad en la aplicación.',
        ]
      },
    ]
  },
  {
    title: 'Versión 2.27',
    date: '12 de Febrero de 2025',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Informe de costes ahorrados en el último año',
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Se han agregado nuevas etiquetas dinámicas de grupos en los correos de aviso de notificaciones, disponible con el módulo "Correos de avisos personalizados"',
          'La fecha de caducidad de los certificados de tipo número de serie ahora es modificable',
          'Correcciones menores.',
        ]
      },
    ]
  },
  {
    title: 'Versión 2.26',
    date: '19 de Diciembre de 2024',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Módulo de respuestas a notificaciones de la AEAT',
          'Informe de últimas vigilancias exportable',
          'Agrupaciones de valores de texto para su utilización en las reglas de reparto'
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Se han corregido los problemas de visualización en algunos PDFs',
          'Añadido desplazamiento paralelo independiente entre el detalle y el PDF en la vista de notificaciones',
          'Correcciones menores.',
        ]
      },
    ]
  },
  {
    title: 'Versión 2.25',
    date: '16 de Octubre de 2024',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Columnas dinámicas de metadatos adicionales en notificaciones, a elección de usuario',
          'Inicio de sesión dinámica en función del tipo de autenticación del usuario',
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Mejoras gráficas y cambios estéticos.',
          'Correcciones menores.',
        ]
      },
    ]
  },
  {
    title: 'Versión 2.24',
    date: '20 de Agosto de 2024',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Mejoras de accesibilidad',
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Correcciones menores.',
        ]
      },
    ]
  },
  {
    title: 'Versión 2.23',
    date: '10 de Julio de 2024',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Módulo de autenticación con integración a través del estándar SAML2',
          'Filtro para la búsqueda de empresas en base a sedes vinculadas, disponible en todas las vistas de empresas',
          'Acción para duplicar agrupaciones desde el detalle de las mismas',
          'Configuración para activar o desactivar el uso de los avisos por correo en los grupos de reparto',
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Correcciones menores.',
        ]
      },
    ]
  },
  {
    title: 'Versión 2.22',
    date: '6 de Junio de 2024',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Módulo de doble factor de autenticación, configurable a nivel de cliente y de usuario.',
          'Configuración de cambio de contraseña en el primer acceso para nuevos usuarios a nivel de cliente.',
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Correcciones menores.',
        ]
      },
    ]
  }, 
  {
    title: 'Versión 2.21',
    date: '18 de Abril de 2024',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Módulo de envío de fichero ZIP adjunto en los avisos de notificaciones descargadas y con opción de renombrado del archivo de forma dinámica con los metadatos de la notificación.',
          'Acción de envío manual de notificaciones por correo a elección en "Para", en "Copia" y en "Copia oculta".',
          'Configuración de SMTP personalizada por Grupos para envíos de aviso de notificaciones con la configuración establecida en el grupo propietario de la notificación. Disponible con el módulo de Configuración SMTP personalizada.',
          'Módulo de asignación de listas de destinatarios a notificaciones de forma automática a través de reglas para el envío de correos de notificaciones de forma posterior.',
          'Módulo para la gestión de permisos de traspaso de notificaciones entre grupos (reasignación, vinculación y desvinculación de notificaciones).',
          'Módulo de gestión de flujos automáticos de notificaciones para enviar avisos y/o cambiar el estado de las notificaciones a un estado concreto tras unos días transcurridos.',
          'Módulo de flujo de aprobación de notificaciones, las notificaciones reasignadas deberán ser aceptadas o rechazadas con motivo de rechazo. Además se añaden otros estados adicionales para su gestión a través de reglas o del módulo de flujos automáticos de estados y avisos.',
          'Persistencia de ordenaciones y agrupaciones en todos los grids.',
          // 'Importación masiva de notificaciones a través de ficheros XML', // SuperAdmin
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Añadida información sobre última regla aplicada a la notificación.',
          'Correcciones menores.',
        ]
      },
    ]
  }, 
  {
    title: 'Versión 2.20',
    date: '19 de Febrero de 2024',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Nuevos vídeos explicativos en la sección de ayuda',
          'Mejoras de seguridad en la aplicación.',
          'Nuevo aviso y filtro de notificaciones en las que ha ocurrido un error al enviar algún correo.',
          'Se ha añadido a las reglas de reparto una configuración de estado de salida opcional al que irán las notificaciones cuando cumplan las condiciones de dicha regla.',
          'Se ha añadido una configuración a nivel de cliente para la descarga de acuses de recibo de algunas sedes.'
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Correcciones menores.',
        ]
      },
    ]
  }, 
  {
    title: 'Versión 2.19',
    date: '18 de Enero de 2024',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Módulo "Importaciones": Importa certificados, empresas, usuarios y grupos de forma masiva a la aplicación usando ficheros .pfx, Excel y .csv.',
          'Estado de notificaciones "Trámite expirado": Contendrá las notificaciones que estuvieran en el estado "Tramitación urgente" y hayan superado la fecha trámite establecida por el usuario.',
          'Estado de notificaciones "Transferida" (descargada y no descargada): Contendrá las notificaciones que hayan sido reasignadas a otro grupo propietario desde un estado de "Puestas a disposición" o "Descargadas para tramitar". Las notificaciones que se reasignen en estados de orden de descarga, esperando procesos o en error no serán actualizadas al nuevo estado.',
          'Se han añadido acciones de reversión que permiten el reintento de descarga de notificaciones para los estados de notificaciones "Expirada", "No descargable", "Archivada sin descargar", "Expirada archivada" y "No descargable archivada".',
          'Nueva opción de gestión de lista blanca de correos a través de Grupos.',
          'Opción para filtrar las notificaciones a las que se tiene acceso con permisos de propietario.',
          'Se ha añadido un diálogo informativo de cambios sin guardar en las vistas de formulario.',
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Mejoras de rendimiento y gráficas en todos los grid.',
          'Nueva acción "Pasar a descarga automática": Añade la notificación al flujo de descarga automática del cliente.',
          'Se ha reorganizado la sección de módulos por categorías.',
          'Se ha añadido licenciamiento por número de notificaciones anuales.',
          'Correcciones menores.',
        ]
      },
    ]
  }, 
  {
    title: 'Versión 2.18',
    date: '4 de Diciembre de 2023',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Nuevo módulo "Horario de descarga": Configura la descarga automática para que se realice sólo en el rango de horas elegido para cada día de la semana.',
          'Nuevo módulo "Calendario de Festivos para Descarga": Configura la descarga automática evitando las descargas los días festivos o cualquier otro día a elección del usuario.',
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Reestructurado el menú de configuración del árbol de navegación para roles AdminDistribuidor y SuperAdminDistribuidor.',
          'Correcciones menores.',
        ]
      },
    ]
  }, 
  {
    title: 'Versión 2.17',
    date: '13 de Noviembre de 2023',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Nuevo módulo "Gama de Colores Personalizada": Selecciona un color y cambia la gama de colores de la aplicación para todos los usuarios del cliente o del distribuidor.',
          'Nuevo módulo "Personalización de Descarga de Ficheros": En la descarga múltiple de documentos, de forma opcional, se añade un filtro por nombre de fichero para los adjuntos descargados, además se añade la opción de cambiar el nombre a los ficheros descargados en base al valor de un metadato seleccionado.',
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Correcciones menores.',
        ]
      },
    ]
  }, 
  {
    title: 'Versión 2.16',
    date: '24 de Octubre de 2023',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Nuevo módulo "Renombrado de ficheros": Cambia el nombre a los ficheros descargados en base al valor de un metadato seleccionado en el momento de descarga múltiple de documentos.',
          'Nuevo módulo "Descarga solo adjuntos principales": Con la configuración activa, se omiten los adjuntos relacionados (no principales) en las descargas de enlaces compartidos de notificaciones, incluidos los avisos de notificaciones descargadas.',
          'Interfaz de personalización de cliente: Interfaz de personalización de los logos principales de la aplicación, cuenta Smtp y editor de asuntos y cuerpos de correos de avisos (es necesario tener contratado los respectivos módulos).',
          'Nueva funcionalidad de Distribuidor: Gestiona múltiples clientes como distribuidor con provisionamiento con bolsa de licenciamiento o de forma libre.',
          'Plantilla de cliente para la actualización y creación de nuevos clientes para usuarios con roles de distribuidor.',
          'Plantilla de personalización de cliente para la actualización y creación de nuevos clientes para usuarios con roles de distribuidor.',
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Correcciones menores.',
        ]
      },
    ]
  }, 
  {
    title: 'Versión 2.15',
    date: '25 de Julio de 2023',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Nuevos módulos disponibles para contratar. Puede consultarlos en la sección de configuración general.',
          'Nueva funcionalidad de Grupos. Las etiquetas ahora son grupos, los grupos mantienen la funcionalidad de etiquetas y añaden: gestión de usuarios, gestión ampliada de notificaciones e integración con Reglas.',
          'Nueva funcionalidad de Reglas. Creación de reglas con condiciones y posibilidad de descarga automática para la asignación de grupos a nuevas notificaciones y a notificaciones descargadas.',
          'Nueva funcionalidad de Agrupaciones. Las agrupaciones permiten crear y gestionar grupos de empresas, grupos de sedes y grupos de organismos, para ser utilizados en las reglas, simplificando el mantenimiento de éstas.',
          'Lista de metadatos adicionales por cliente para utilizar en Reglas y en la opción de añadir metadatos adicionales a las notificaciones.',
          'Lista blanca de emails por cliente para reenvíos de notificaciones y lista negra de emails, para evitar envíos a ciertos correos.',
          'Plantilla de grupos de gestión, para dejar predefinidos valores por defecto al crear nuevos grupos.',
          'Actualización del perfil de usuario con información sobre los grupos a los que pertenece.',
          'Nuevo componente de visualización de PDF, con búsqueda por texto, visualización de propiedades del documento y más mejoras.',
          'Opción de aplicar sedes y exclusiones a empresas solo para sedes contratadas seleccionadas.',
          'Nuevas opciones de configuración de avisos a nivel general en la sección de configuración general.',
        ]
      },
      {
        title: 'Otros cambios',
        description: [
          'Mejoras gráficas y cambios estéticos.',
          'Se ha reestructurado la sección de Configuración en el árbol de navegación. Para usuarios Administradores.',
          'Correcciones en textos y descripciones.',
          'Se han reestablecido la configuración de columnas de las vistas de Notificaciones, Empresas y Usuarios por compatibilidad.',
          'Otras correcciones menores.',
        ]
      },
    ]
  }, 
  {
    title: 'Versión 2.14',
    date: '16 de Mayo de 2023',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Nuevo Módulo contratable de Vacaciones fiscales: Consulta y solicitud de los días de cortesía a la sede AEAT, de forma masiva y de forma individual por cada empresa.',
          'Nuevo Módulo contratable de Avisos por SMS: Envío de un SMS a un número de teléfono por cada notificación descargada, configurable por cada empresa.',
          'Nuevo Módulo contratable de Notificaciones de Terceros: Se incluyen las notificaciones de apoderados en los casos de las sedes DEHú y AEAT.',
          'Nuevo Módulo contratable de Control de Duplicados: Se controlan las notificaciones duplicadas de algunas sedes contra el concentrador DEHú.',
          'Vista de configuración general para usuarios con rol Administrador, donde puede configurarse la caducidad de los usuarios y ver los módulos contratados.',
          'Filtros generales por cliente a todas las vistas para usuarios con rol SuperAdministrador.',
          'Opción de deshabilitar la carga del dashboard por defecto para los usuarios con rol SuperAdministrador.',
        ]
      },
      {
        title: 'Errores corregidos',
        description: [
          'Otras correcciones menores.',
        ]
      },
    ]
  }, 
  {
    title: 'Versión 2.13',
    date: '10 de Abril de 2023',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Cambios en el árbol de navegación de Notificaciones: Nuevos grupos contraíbles para mejorar la organización, icono de alerta para estados de la notificación que requieren atención.',
          'Nuevos estados de notificaciones: Expirada archivada, No descargable archivada y Descarga externa.',
          'Edición de campos de múltiples empresas a seleccionar, de forma masiva. Accesible desde las acciones de la vista de empresas al seleccionar, o desde la plantilla de empresas con la opción "Editar campos".',
          'Ahora es posible configurar en la sección de empresas y plantilla, los avisos de última llamada, de tramitación urgente y de notificaciones en error de forma independiente con sus respectivos correos electrónicos. Además también es posible activar y desactivar la ejecución de estos avisos eliminando el contenido de cada campo.',
          'Añadidas opciones para el traspaso de permisos desde usuarios, en las secciones de entidades vinculadas a un usuario.',
          'Nuevos filtros por metadatos adicionales en las notificaciones.',
          'Nuevo gráfico para visualizar el estado del licenciamiento en la sección Dashboard.',
          'Limitación en la visibilidad de los certificados por parte de usuarios con rol Usuario y Consulta, ahora solo pueden visualizar los certificados que suba el propio usuario y los que estén vinculados a las empresas a las que tengan acceso.',
          'Se ha añadido un control sobre el número de conexiones permitidas por cliente para usuarios SuperAdministrador.',
        ]
      },
      {
        title: 'Errores corregidos',
        description: [
          'Otras correcciones menores.',
        ]
      },
    ]
  }, 
  {
    title: 'Versión 2.12',
    date: '23 de Enero de 2023',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          // 'Cambio seguridad contraseñas usuarios',
          // 'Codigo externo SageWeb',
          'Ahora es posible autenticarse con email de forma opcional a través de la autenticación estándar.',
          'Nuevo tipo de usuario: Usuario Consulta. Usuario para consulta y revisión de datos, similar al rol "Usuario" con restricciones a la hora de realizar acciones sobre notificaciones, solo puede visualizarlas y descargar el contenido de éstas.',
          'Se han añadido filtros al grid de Errores detectados de vigilancias, en el Dashboard. Filtros múltiples por empresas y por sedes accesibles desde la cabecera de la tabla de errores.',
          'Añadida campo fecha de fin trámite en el formulario de generación de una nueva notificación de forma manual.',
          'Añadida la opción de selección de cliente en el Dashboard para usuarios con rol "SuperAdministrador". Al seleccionar un cliente se filtrarán todos los datos de la vista y todas las acciones derivadas de la vista con el cliente seleccionado.',
        ]
      },
      {
        title: 'Errores corregidos',
        description: [
          'Rendimiento del Dashboard mejorado',
          'Correciones en modo oscuro.',
          'Otras correciones menores',
        ]
      },
    ]
  }, 
  {
    title: 'Versión 2.11',
    date: '13 de Diciembre de 2022',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Nuevo tipo de usuario: Usuario Consulta. Usuario para consulta y revisión de datos, similar al rol "Usuario" con restricciones a la hora de realizar acciones sobre notificaciones, solo puede visualizarlas y descargar el contenido de estas.',
          'Nueva funcionalidad de edición y eliminación de Metadatos Adicionales de una notificación, accesible en el detalle de las notificaciones.',
          'Se ha añadido la opción de exportar un fichero excel de los errores detectados, desde el cuadro de diálogo de los detalles de errores del Dashboard.',
          'Se ha añadido una nueva opción de exportar un fichero excel del histórico completo de los errores detectados, de una empresa y una sede concretos, desde el cuadro de diálogo de los detalles de errores del Dashboard.',
          // 'Se ha añadido la opción de generar "Poderdantes automáticos en AEAT" por cliente, con esta opción activa se generarán y asociarán automáticamente empresas con los nuevos CIF encontrados como poderdante en un certificado al realizar vigilancias en la Sede AEAT a su certificado correspondiente.',
          'Al seleccionar la acción "Excluir organismo asociado" desde la vista de notificaciones, se ha añadido la opción de excluir dicho organismo a todas las empresas del cliente, además de mantenerse la opción por defecto de solo excluir el organismo a la empresa asociada a esa notificación.',
        ]
      },
      {
        title: 'Errores corregidos',
        description: [
          'Corregido error en la subida de notificaciones manualmente.',
          'Correciones en textos y descripciones.',
          'Otras correciones menores',
        ]
      },
    ]
  }, 
  {
    title: 'Versión 2.10',
    date: '10 de Noviembre de 2022',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Añadido visualización de errores en vigilancias a sedes. Ahora desde el Dashboard se encontrará un nuevo botón "Detalles de errores" con el que podremos visualizar los errores encontrados al realizar las vigilancias por empresa y sede electrónica, además de un histórico de los mismos.',
          'Añadida gestión de organismos excluidos al realizar vigilancias por sedes contratadas del cliente y por sedes vinculadas a las empresa y opción "Revisar todo" para revisar todas las sedes obviando los organismos excluidos en casos de existir. Accesible desde "Sedes Contratadas" y desde "Sedes vinculadas" en Empresas',
          'Al realizar subidas de certificados se realizarán validaciones de contraseña y caducidad y posteriormente se comprobará si existe ya una empresa creada con ese CIF, para poder crearla y/o vincular el certificado a la misma.',
          'Añadido Chat con soporte técnico, en la esquina inferior derecha con posibilidad de ocultarlo.',
          'Opción de caducidad de sesión automáticamente por inactividad del usuario, configurable en el perfil de usuario. Por defecto se encuentra desactivado.',
          'Añadido campo de error en el detalle de la notificación en caso de encontrarse en un estado de error.',
          'Añadida configuración por cliente de datos de contacto para Gran Destinatario en DEHú.',
          'Se ha añadido un indicador para las notificaciones subidas manualmente a la aplicación, visualizable desde el detalle de la notificación en la parte superior, además de un nuevo filtro por este valor en la vista de notificaciones.',
          'Ahora se genera una configuración inicial por defecto en la plantilla de empresas al crear un cliente donde se llenan los campos de email con el del usuario inicial.',
        ]
      },
      {
        title: 'Errores corregidos',
        description: [
          'Corregido error en la subida de certificados que ocurría con algunos ficheros pfx.',
          'Corregido sobrecarga de memoria al cargar muchos organismos en componentes de selección. Limitado a 200 organismos como máximo, en caso contrario será necesario limitar la búsqueda.',
          'Corregidas acciones de creación de empresas, usuarios y certificados con entidades ya creadas o borradas.',
          'Correciones al aplicar búsquedas con ciertos filtros.',
          'Correciones gráficas en interfaces.',
          'Correciones en textos y descripciones.'
        ]
      },
    ]
  }, 
  {
    title: 'Versión 2.9.0',
    date: '13 de Octubre de 2022',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          // 'Añadido Chat con soporte técnico, en la esquina inferior derecha con botón para ocultarlo.',
          'Añadida nueva funcionalidad de reemplazo de certificados. Ahora se puede reemplazar un certificado por uno nuevo mantiendo los vínculos con las empresas del antiguo. La acción está disponible desde el Grid de Certificados (seleccionando uno) o desde el detalle de un certificado.',
          'Nuevos avisos para notificaciones tramitadas. Ahora es posible añadir un nuevo correo en las empresas de forma opcional al que se enviará un aviso de las notificaciones tramitadas de dicha empresa. También configurable en la plantilla para la creación de empresas.',
          'Ahora los filtros por "Sede" y "Estado" son múltiples, en la sección de Notificaciones.',
          'Se ha añadido la columna "Certificado asociado" en la vista de Empresas, que indica si la empresa tiene o no un certificado vinculado a la misma, además de un nuevo filtro para buscar por este valor.',
          'Se ha añadido el filtro "En uso" en la vista de Certificados, acorde a la columna ya existente.',
          'Añadida licencia de uso, visualizable desde el panel de ayuda.',
        ]
      },
      {
        title: 'Errores corregidos',
        description: [
          'Corregido disparador de visualización de las notas de la versión.',
          'Corregido mensaje incorrecto de validación en el formulario de notificaciones a mano.',
          'Corregido funcionamiento incorrecto de búsquedas que usan el filtro "Tipo" en notificaciones.',
          'Ahora al generar una notififcación a mano, el formulario se limpia correctamente.',
          'En las secciones de notificaciones se ha corregido el funcionamiento del filtro "CIF Titular" y se ha añadido el filtro "CIF" relacionado al CIF de la empresa vinculada a la notificación.',
          'Reajustes de la interfaz en el detalle de la notificación, en la vista de autenticación y en el panel de ayuda.',
          'Correciones en textos y descripciones.'
        ]
      },
    ]
  }, 
  {
    title: 'Versión 2.8.0',
    date: '23 de Septiembre de 2022',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Visibilidad de almacenamiento disponible para los documentos de las notificaciones desde el Dashboard y en el detalle del cliente para usuario SuperAdministrador.',
          'Añadido un panel de ayuda e información accesible desde el menú desplegable de usuario con información sobre los últimos cambios y manuales de uso de la aplicación.',
          'Ahora se puede visualizar una descripción de los estados de notificaciones al pasar el cursor sobre ellas en el menú de navegación izquierdo.',
          'Añadido campo Código Externo al cliente en el Grid con filtro, y en el detalle del cliente',
          'Mejorado el componente de subida de adjuntos en Notificaciones a mano y en el detalle de la notificación.',
        ]
      },
      {
        title: 'Errores corregidos',
        description: [
          'Correciones en la subida de adjuntos desde Notificaciones a mano y detalle de la notificación.',
          'Correción de desfase de dos horas en la fecha de algunas notificaciones.',
        ]
      },
    ]
  }, 
  {
    title: 'Versión 2.7.0',
    date: '12 de Septiembre de 2022',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Opción de exportación a Excel de las filas seleccionadas en cualquier Grid.',
          'Descarga masiva local de los documentos de notificaciones ya descargadas, al seleccionar notificaciones en las acciones de la vista Notificaciones.',
          'Añadido filtro por estado en la vista principal de Notificaciones.',
        ]
      },
      // {
      //   title: 'Errores corregidos',
      //   description: [
      //     '....',
      //   ]
      // },
    ]
  }, 
  {
    title: 'Versión 2.6.3',
    date: '6 de Septiembre de 2022',
    changes: [
      {
        title: 'Nuevas características',
        description: [
          'Ahora los filtros aplicados se mantienen en las distintas vistas al navegar.',
          'Nuevo filtro para búsqueda por el contenido de las notas en la sección Notificaciones.',
          'Añadida la hora a la fecha de las últimas revisiones en el Dashboard.',
        ]
      },
      {
        title: 'Errores corregidos',
        description: [
          'Mensajes en cuadros de diálogos incorrectos.',
          'Se han solucionado errores visuales en la selección de filas en los Grid.',
          'Fecha de descarga desconocida que no correspondía en el detalle de la notificación.',
          'Correcciones menores generales en filtros.',
        ]
      },
    ]
  },
]

export {
  PATCH_NOTES
}
